module.exports = __webpack_public_path__ + "media/images/tigor/tigor2-383263328d0937b1a347781f5b1d2c95.png";